import { sportSchema, thresholdSportSchema, weekStartSchema, type Sport, type ThresholdSport } from '@painpal/contracts';

export interface SignInSearch { mode?: 'sign-up'; error?: 'strava' }
export interface ActivitiesSearch { sport?: Sport; upload?: true }

export function parseSignInSearch(search: Record<string, unknown>): SignInSearch {
  return {
    mode: search.mode === 'sign-up' ? 'sign-up' : undefined,
    error: search.error === 'strava' ? 'strava' : undefined,
  };
}

export interface StravaReturnSearch { error?: string }

export function parseStravaReturnSearch(search: Record<string, unknown>): StravaReturnSearch {
  return { error: typeof search.error === 'string' ? search.error : undefined };
}

export interface SettingsSearch extends StravaReturnSearch { sport?: ThresholdSport }

export function parseSettingsSearch(search: Record<string, unknown>): SettingsSearch {
  return { ...parseStravaReturnSearch(search), sport: thresholdSportSchema.safeParse(search.sport).data };
}

export function parseActivitiesSearch(search: Record<string, unknown>): ActivitiesSearch {
  return {
    sport: sportSchema.safeParse(search.sport).data,
    upload: search.upload === true || search.upload === 'true' ? true : undefined,
  };
}

export interface CalendarSearch { week?: string }

// Only a real Monday pages the calendar; anything else opens the current week.
export function parseCalendarSearch(search: Record<string, unknown>): CalendarSearch {
  return { week: weekStartSchema.safeParse(search.week).data };
}

export interface FitnessSearch { sport?: Sport }

// Only a real sport filters the Fitness page; anything else shows ALL.
export function parseFitnessSearch(search: Record<string, unknown>): FitnessSearch {
  return { sport: sportSchema.safeParse(search.sport).data };
}
